import { Column } from "react-table";
import { PermitRegister } from "../models/PermitRegister";
import { ActionItem } from "./GridActionButton";
import { DataGridNoPagination } from "./common/DataGridNoPagination";

interface Props {
  permitRegisters?: PermitRegister[] | null;
  selectedPermitRegister?: PermitRegister;
  onEditPermitRegister: (registerId: string) => void;
  onDeletePermitRegister: (registerId: string) => void;
  onPermitRegisterClicked: (register: PermitRegister) => void;
}

const PermitRegistersGrid = ({
  permitRegisters,
  selectedPermitRegister,
  onEditPermitRegister,
  onDeletePermitRegister,
  onPermitRegisterClicked,
}: Props) => {
  const actionItems = [
    {
      key: "edit",
      icon: "edit",
      content: "Edit",
      callback: (id: string) => onEditPermitRegister(id),
    },
    {
      key: "delete",
      icon: "delete",
      content: "Delete",
      callback: (id: string) => onDeletePermitRegister(id),
    },
  ] as ActionItem[];

  const columns: Column<PermitRegister>[] = [
    {
      Header: "Title",
      id: "Title",
      accessor: (p) => p.title,
    },
    {
      Header: "Description",
      id: "Description",
      accessor: (p) => p.description,
    },
  ];

  const handlePermitRegisterClicked = (register: PermitRegister, i: number) => {
    onPermitRegisterClicked(register);
  };

  return (
    <>
      <DataGridNoPagination
        columns={columns}
        actionItems={actionItems}
        actionButtonColumn={columns[1]}
        data={permitRegisters ? permitRegisters : []}
        selectedRow={selectedPermitRegister}
        onRowClick={handlePermitRegisterClicked}
        onPageInfoChange={() => {}}
        loading={false}
      />
    </>
  );
};

export default PermitRegistersGrid;
